import { render, staticRenderFns } from "./editList2.vue?vue&type=template&id=4bd7f474"
import script from "./editList2.vue?vue&type=script&lang=js"
export * from "./editList2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports